import BuyTokensDisplay from '@organisms/BuyTokensDisplay';
import { withAuthGate } from '@sunrise-ui/composites';
import React from 'react';

function TokensScreen() {
  return <BuyTokensDisplay />;
}

export default withAuthGate(TokensScreen);
